import { render, staticRenderFns } from "./ProfileAndVerification.vue?vue&type=template&id=408e7dad&scoped=true"
import script from "./ProfileAndVerification.vue?vue&type=script&lang=js"
export * from "./ProfileAndVerification.vue?vue&type=script&lang=js"
import style0 from "./ProfileAndVerification.vue?vue&type=style&index=0&id=408e7dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408e7dad",
  null
  
)

export default component.exports